import type sv from '../sv/common'

const common: typeof sv = {
  app: { name: 'HUB' },
  nav: {
    calendar: 'Calendar',
    draw: 'Whiteboard',
    write: 'Documents',
    tasks: 'Tasks',
    inbox: 'Inbox',
    chat: 'Chat',
    settings: 'Settings',
    profile: 'Profile settings',
    meetings: 'Meeting',
  },
  userMenu: {
    profileSettings: 'Profile settings',
    superAdmin: 'Super Admin',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    language: 'Language',
    logout: 'Log out',
    anonymous: 'User',
    loggingOut: 'Logging out...',
  },
  voice: {
    female: 'Female',
    male: 'Male',
  },
  language: {
    sv: 'Svenska',
    en: 'English',
  },
  mobileNav: {
    openMenu: 'Open menu',
    menu: 'Menu',
    description: 'Navigation and chats',
  },
  navbar: {
    connecting: 'Connecting…',
    disconnected: 'Disconnected',
    renameTitle: 'Rename',
  },
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    rename: 'Rename',
    retry: 'Retry',
    copy: 'Copy',
    copied: 'Copied',
    search: 'Search',
    open: 'Open',
    create: 'Create',
    add: 'Add',
    remove: 'Remove',
    back: 'Back',
    continue: 'Continue',
    confirm: 'Confirm',
    download: 'Download',
    upload: 'Upload',
    send: 'Send',
    loading: 'Loading…',
    saving: 'Saving…',
  },
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
    justNow: 'Just now',
  },
  errors: {
    generic: 'Something went wrong',
    network: 'Network error',
    notFound: 'Not found',
    unauthorized: 'You must be signed in',
    forbidden: 'You do not have permission',
  },
  errorPage: {
    title: 'This page could not be shown',
    body: 'Something went wrong while showing this page. Try again, or go to the project overview.',
    staleBody:
      'HUB has been updated since you opened this tab, so part of the page is missing. Reload to get the new version.',
    persistHint:
      'Happens again? Reload the page and tell us what you were doing, ideally with the error id below.',
    tryAgain: 'Try again',
    reload: 'Reload page',
    goToProject: 'Go to the project overview',
    goHome: 'Go to the start page',
    technicalDetails: 'Technical details',
    errorId: 'Error id',
    route: 'Page',
    version: 'Version',
    componentStack: 'Components',
  },
  newVersion: {
    title: 'A new version of HUB is available',
    description: 'Reload the page to get the latest changes.',
    reload: 'Reload',
  },
  presence: {
    online: 'Online',
    goTo: 'Go to',
  },
  sidebar: {
    expand: 'Expand sidebar',
    collapse: 'Hide sidebar',
    projectFallback: 'Project',
    projects: 'Projects',
    newProject: 'New project',
    searchProjects: 'Search projects…',
    noProjectsMatch: 'No projects match',
    chats: 'Chats',
    newChat: 'New chat',
    lastMessage: 'Last message {{when}}',
    noChats: 'No chats yet',
    agentWorking: 'The agent is working',
    pinned: 'Pinned',
    recent: 'Recent',
    allChats: 'All chats',
    pin: 'Pin',
    unpin: 'Unpin',
    renameChatTitle: 'Rename chat',
    renameChatDescription: 'Enter a new name for the chat.',
    chatNamePlaceholder: 'Chat name',
    deleteChatTitle: 'Delete chat',
    deleteChatConfirm: 'Are you sure you want to delete "{{title}}"? This cannot be undone.',
    deleting: 'Deleting...',
  },
  home: {
    noProjectsTitle: 'No projects yet',
    noProjectsBody: 'You have no projects yet. Ask an administrator to invite you to a project.',
    goToAdmin: 'Go to Admin',
  },
  project: {
    loading: 'Loading project...',
    notFoundTitle: 'Project not found',
    notFoundBody: 'The project could not be loaded or you do not have access.',
    goHome: 'Go to the start page',
  },
  createProject: {
    title: 'New project',
    count: '{{count}}/{{limit}} projects',
    limitReached:
      'You have reached the limit of {{limit}} projects. Delete a project to create a new one.',
    organization: 'Organisation',
    name: 'Project name',
    namePlaceholder: 'My project',
    icon: 'Icon',
    creating: 'Creating...',
    submit: 'Create project',
    failed: 'Could not create the project.',
  },
  credits: {
    label: 'Usage',
    percent: '{{percent}}%',
    orgLine: '{{used}} of {{limit}} credits used',
    projectLine: 'This project: {{used}} of {{cap}} credits',
    periodEnd: 'Period resets {{date}}',
    blocked: 'Out of credits — new replies, read-aloud and dictation are paused.',
  },
  projectList: {
    recentProjects: 'Recent projects',
    members_one: '{{count}} member',
    members_other: '{{count}} members',
    hoursAgo_one: '{{count}} hour ago',
    hoursAgo_other: '{{count}} hours ago',
    daysAgo_one: '{{count}} day ago',
    daysAgo_other: '{{count}} days ago',
    status: {
      inProgress: 'In progress',
      planning: 'Planning',
      review: 'Review',
    },
  },
}

export default common
